import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { validateEnv } from "../../config/env";

export function LoginPage() {
  const { user, signIn, normalizeError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  if (user) {
    return <Navigate to="/suporte" replace />;
  }

  const envCheck = validateEnv();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setLoading(true);

    try {
      await signIn(email, password);
    } catch (error) {
      setErrorMessage(normalizeError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
          <div className="app-shell-logo" aria-hidden>
            L
          </div>
          <div>
            <h1 style={{ margin: 0 }}>Linqer</h1>
            <p style={{ margin: 0, fontSize: 13 }}>Portal de suporte</p>
          </div>
        </div>
        <p>Acesso liberado apenas para agentes de suporte autorizados no IAM.</p>

        {!envCheck.isValid && (
          <div className="error-box">
            Variáveis não configuradas: {envCheck.missing.join(", ")}
          </div>
        )}

        <label htmlFor="email">E-mail</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
        />

        <label htmlFor="password">Senha</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        />

        {errorMessage && <div className="error-box">{errorMessage}</div>}

        <button className="primary-button" type="submit" disabled={loading || !envCheck.isValid}>
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
